import styled from 'styled-components';
import { PAGE_CONTAINER } from '../../../styles/Layout';
import { ThemeColours } from '../../../styles/ThemeColours';
import { Breakpoint, FontSize, FontWeight } from '../../../styles/constants';
import { LinkButton } from '../../Button/LinkButton/LinkButton';

export const PracticeSectionView = styled.div`
  align-items: center;
  background-color: ${ThemeColours.primary100};
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  ${PAGE_CONTAINER};
  padding-bottom: 16px;
  padding-top: 16px;
`;

export const HeyKid = styled.div`
  color: ${ThemeColours.mono900};
  font-size: ${FontSize.REGULAR};
  font-weight: ${FontWeight.REGULAR};
  margin-right: 16px;
  text-align: center;
`;

export const HeyKidB = styled.b`
  font-weight: ${FontWeight.SEMI_BOLD};
`;

export const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  padding-top: 8px;
  width: 100%;

  ${Breakpoint.SMALL} {
    padding-top: 0;
    width: fit-content;
  }
`;

export const BannerLinkButton = styled(LinkButton)`
  width: fit-content;
`;
